import { render, staticRenderFns } from "./NotificacaoLista.vue?vue&type=template&id=3203a868&scoped=true"
import script from "./NotificacaoLista.vue?vue&type=script&lang=js"
export * from "./NotificacaoLista.vue?vue&type=script&lang=js"
import style0 from "./NotificacaoLista.vue?vue&type=style&index=0&id=3203a868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3203a868",
  null
  
)

export default component.exports